import React from 'react';
import { Link } from 'react-router-dom';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Row, Col } from 'antd';

import ChargebackAlert from 'v2/components/Shared/ChargebackAlert';

interface IProps {
  title: string | React.ReactNode;
  extra?: React.ReactNode;
  helpLink?: string;
  helpText?: string;
  goBackTo?: string;
  action?: React.ReactNode;
  additionalContent?: React.ReactNode;
  disableAlerts?: boolean;
}

function TopPage({
  title,
  extra,
  helpLink,
  helpText = 'Ajuda',
  goBackTo,
  action,
  additionalContent,
  disableAlerts = false
}: IProps) {
  return (
    <>
      <Row>
        {!disableAlerts && (
          <Col span={24}>
            <ChargebackAlert />
          </Col>
        )}

        <Col span={24} className='mt-4'>
          <div className='relative mb-6 flex gap-4 max-sm:flex-col [&>div]:flex [&>div:first-of-type]:flex [&>div:first-of-type]:grow [&>div:first-of-type]:items-center'>
            <div>
              {!!goBackTo && (
                <Link
                  to={goBackTo}
                  id='go-back-button'
                  className='text-grey-500 mr-6 flex cursor-pointer items-center [&>span]:mr-1'
                >
                  <ArrowLeftOutlined aria-hidden='true' />
                  Voltar
                </Link>
              )}
              <div className='my-title'>
                <h1>{title}</h1>
                {!!extra && <p>{extra}</p>}
              </div>
            </div>
            {!!action && <>{action}</>}

            {additionalContent}

            {!!helpLink && (
              <Button className='border-grey-300 border' href={helpLink} target='_blank'>
                {helpText}
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
}

export default TopPage;
